import React from "react";
import { ReactComponent as Logo } from '../assets/footerlogo.svg';
import { FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";
import FONDO from "../assets/foot.jpg";
import { Link } from "react-router-dom";
const Footer = () => {
	const redes = [
		{ icon: FaWhatsapp, url: "https://api.whatsapp.com/send/?phone=522227755636&text&type=phone_number&app_absent=0" },
		{ icon: FaFacebook, url: "https://www.facebook.com/profile.php?id=100064057091196#" },
		{ icon: FaInstagram, url: "https://www.instagram.com/grupodeautoresaplicados/" },
	];

	return (
		<footer
			className="relative bg-top bg-no-repeat bg-cover h-fit w-full grid grid-cols-1 p-4 bg-[#028299] shadow text-white pt-[120px] md:pt-[170px] gap-12 pb-20"
			style={{ backgroundImage: `url(${FONDO})` }}
		>
		<div className="absolute inset-0 bg-slate-700/75" />
			<div className="absolute top-0 left-0 w-full overflow-hidden leading-none z-10">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1440 155"
                    preserveAspectRatio="none"
                    className="w-full h-[100px] md:h-[150px]"
                >
                    <path
                        d="M0,71.7169637 C390.59867,-37.9017759 919.556541,-69.8103913 1440,70.6533432 C1440,83 1440,134.065337 1440,155 C1422.97118,155 942.971175,155 0,155 C0,107 0,79.2389879 0,71.7169637 Z"
                        fill="#FFFFFF"
                        transform="translate(720, 66) scale(1, -1) translate(-720, -66)"
                    />
                </svg>
            </div>

			<div className="grid grid-cols-1 md:grid-cols-2 place-content-start place-items-start items-start gap-8 px-4 z-50">
				<div className="w-full">
					<Logo className="w-44"/>
				</div>
				<div className="grid grid-cols-1 gap-2">
					<h2> Envíenos un correo electrónico: </h2>
					<strong className="text-3xl font-bold"> gdagrupodeautores@outlook.com </strong>
				</div>
				<div className="h-auto">
					<h2 className="text-3xl"> ¡Hablemos! </h2>
				</div>
				<div className="flex flex-col">
					<p>También puedes encontrarnos aquí:</p>
					<div className="flex flex-row justify-around">
					{redes.map((red, index) => {
						const Icon = red.icon;
						return (
							<a
								key={index}
								href={red.url}
								target="_blank"
								rel="noopener noreferrer"
								aria-label={red.name}
								className="text-white text-2xl hover:text-yellow-300 transition-colors"
								>
								<Icon />
							</a>
						);
					})}
					</div>
				</div>
				<p>
					¿Tiene alguna pregunta o comentario? Háganoslo saber.
				</p>
				<p>
					CONOCE UN POCO MÁS DE NUESTRO TRABAJO:
				</p>
				<div className="grid grid-cols-1 gap-2">
					<strong> Dirección </strong>
					<p>
						{" "}
						CPrivada 3 B Sur, Número EXT. 3705
						Col. Gabriel Pastor, Heroica Puebla de Zaragoza. C.P. 72420
						{" "}
					</p>
				</div>
				<a
					href="https://www.gdamagazine.com/"
					target="_blank"
                    rel="noopener noreferrer"
					className="text-center p-4 w-64 bg-white text-teal-500 text-lg font-bold rounded-full"
				>
					GDA MAGAZINE
				</a>
			</div>
			<div className="w-full h-1 bg-teal-400 my-4 z-50"/>
			<div className="z-50 grid grid-cols-2 text-sm">
				<p className="text-gray-300">Todos los derechos reservados | Grupo de Autores Aplicados GDA © 2025</p>
				<Link className="text-sky-300 underline" to={"/privacity"} >Términos de privacidad & condiciones</Link>
			</div>
		</footer>
	);
};

export default Footer;
